import React from 'react'
import View from './view'

export default function Logic(props) {
  return <View {...props} />
}
